module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-240.666b4f6a.svg";